// 必须作为入口文件的第一个 import，以确保 console hook 最早生效
import { hookConsole } from '@/capacitor/logger/simplelogger';
import { Capacitor } from '@capacitor/core';

// 此处执行 hook，确保能捕获后续所有模块（包括第三方库）在初始化阶段产生的 console 输出
const enableWebConsoleHook = (import.meta as any).env?.VITE_ENABLE_WEB_CONSOLE_HOOK === 'true';
// - DEV：默认启用 hookConsole()，以便浏览器下的 日志页 能展示本次会话的 console 日志。
if (Capacitor.isNativePlatform() || enableWebConsoleHook || ((import.meta as any).env?.DEV && Capacitor.getPlatform() === 'web')) {
  hookConsole();
}
export {};
